import React, { ReactElement } from 'react';
import { withRouter } from 'react-router';
import useStyles from './styles';
import LeafletMap from '../../components/molecules/leaflet_map';

interface IProps {
}

const MapsPage = (props : IProps) : ReactElement => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LeafletMap scrollWheelZoom={true} />
    </div>
  );
};

export default withRouter(MapsPage);
